import { useEffect, useState } from "react";
import { Copy, Check, Download, Smartphone, Share } from "lucide-react";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function InstallCard() {
  const url = window.location.origin;
  const [copied, setCopied] = useState(false);
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); toast.success("Aplikasi terpasang di layar utama"); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Alamat disalin"); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error("Tidak bisa menyalin otomatis — salin manual dari kolom alamat."); }
  };
  const install = async () => { prompt.prompt(); await prompt.userChoice; setPrompt(null); };
  const share = async () => { try { await navigator.share({ title: "YUTAKA MANABI", url }); } catch (e) { if (e?.name !== "AbortError") console.warn("share failed", e?.message); } };

  return (
    <div className="soft-card overflow-hidden" data-testid="install-card">
      <div className="grid gap-5 p-6 sm:grid-cols-[1fr_auto] sm:items-center">
        <div>
          <div className="flex items-center gap-2 text-xs uppercase tracking-wide text-muted-foreground"><Smartphone className="h-3.5 w-3.5" />Buka di HP · iOS, Android, HarmonyOS</div>
          <p className="mt-2 text-sm text-muted-foreground">Alamat aplikasi (sama untuk semua perangkat):</p>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <code data-testid="install-url" className="rounded-lg bg-muted px-3 py-2 text-sm font-medium break-all">{url}</code>
            <button data-testid="install-copy-button" onClick={copy} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-2 text-xs font-semibold hover:bg-accent">{copied ? <Check className="h-3.5 w-3.5 text-sage" /> : <Copy className="h-3.5 w-3.5" />}{copied ? "Tersalin" : "Salin alamat"}</button>
            {navigator.share && <button data-testid="install-share-button" onClick={share} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-2 text-xs font-semibold hover:bg-accent"><Share className="h-3.5 w-3.5" />Bagikan</button>}
          </div>
          <div className="mt-4">
            {installed ? (
              <span data-testid="install-installed-badge" className="inline-flex items-center gap-1.5 rounded-full bg-sage-soft px-3 py-1.5 text-xs font-semibold text-sage"><Check className="h-3.5 w-3.5" />Sudah terpasang di perangkat ini</span>
            ) : prompt ? (
              <button data-testid="install-app-button" onClick={install} className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5"><Download className="h-4 w-4" />Pasang aplikasi</button>
            ) : (
              <p data-testid="install-hint" className="text-xs text-muted-foreground">{isIOS ? "iPhone/iPad: Safari → tombol Bagikan → 'Tambah ke Layar Utama'." : "Android/HarmonyOS: menu browser (⋮ atau ≡) → 'Tambahkan ke layar utama' / 'Instal aplikasi'. Langkah lengkap di bawah."}</p>
            )}
          </div>
        </div>
        <div className="flex flex-col items-center gap-2 self-start sm:self-center">
          <img data-testid="install-qr" src={`${BASE}/api/guide/qr?url=${encodeURIComponent(url)}`} alt="QR alamat aplikasi" className="h-36 w-36 rounded-xl border border-border bg-white p-1" />
          <span className="text-[11px] text-muted-foreground">Pindai dengan kamera HP</span>
        </div>
      </div>
    </div>
  );
}
